import { createAuthClient } from 'better-auth/react';

function resolveBaseURL(): string {
  const raw = import.meta.env.VITE_AUTH_BASE;
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173';

  if (raw) {
    return raw.startsWith('http') ? raw : `${origin}${raw}`;
  }
  return `${origin}/api/auth`;
}

export const authClient = createAuthClient({ baseURL: resolveBaseURL() });

export const { useSession, signIn, signUp, signOut } = authClient;
